document.addEventListener('DOMContentLoaded', function() {
  const slider = document.getElementById('collectionCircleSlider');
  if (!slider) return;

  // Performance optimization variables
  let rafId = null;
  let isScrolling = false;
  let scrollEndTimer = null;
  let lastTime = 0;
  
  // Get all items without cloning
  const items = slider.querySelectorAll('.collection-circle-item');
  if (items.length === 0) return;

  // Remove scroll-snap behavior that causes step-by-step movement
  slider.style.scrollBehavior = 'smooth';
  slider.style.scrollSnapType = 'none'; // Remove snap points for fluid scrolling
  slider.style.webkitOverflowScrolling = 'touch'; // Better iOS momentum scrolling
  
  // Add item styles for smoother, more continuous scrolling
  items.forEach(item => {
    // Remove scroll snap alignment to allow continuous scrolling
    item.style.scrollSnapAlign = 'none';
    // Add transition for smoother movement during dragging
    item.style.transition = 'transform 0.2s ease';
  });

  // Add click handlers for items
  function setupClickHandlers() {
    document.querySelectorAll('.collection-circle-item').forEach(item => {
      item.addEventListener('click', event => {
        if (!item.hasAttribute('data-dragging') || item.getAttribute('data-dragging') === 'false') {
          const url = item.getAttribute('data-url');
          if (url) window.location.href = url;
        }
      });
    });
  }
  
  setupClickHandlers();

  // Improved scroll implementation with hardware acceleration
  let isDragging = false;
  let startX, currentX, initialScrollLeft;
  let hasMoved = false;
  let autoScrolling = false;
  let autoScrollSpeed = 0.5; // Pixels per frame (slower for smoother auto-scroll)
  
  // Precise drag threshold - important for distinguishing clicks from drags
  const dragThreshold = 5; // Pixels

  // Helpers to store positions for momentum
  let positions = [];
  const maxPositions = 20; // Track more positions for ultra-smooth momentum calculation

  // Prevent context menu to enable right-drag
  slider.addEventListener('contextmenu', e => e.preventDefault());

  // Enhanced hardware acceleration optimization
  slider.style.transform = 'translateZ(0)';
  slider.style.willChange = 'scroll-position';
  slider.style.backfaceVisibility = 'hidden';
  slider.style.perspective = '1000px';

  function startDrag(e) {
    const isTouch = e.type.includes('touch');
    const pageX = isTouch ? e.touches[0].pageX : e.pageX;
    
    // For mouse events, prevent default to avoid text selection
    if (!isTouch) {
      e.preventDefault();
    }
    
    isDragging = true;
    hasMoved = false;
    startX = pageX;
    currentX = pageX;
    initialScrollLeft = slider.scrollLeft;
    positions = [{time: Date.now(), position: pageX}];
    
    // Pause auto-scroll during drag
    pauseAutoScroll();
    
    // Add dragging state class and cursor
    slider.classList.add('dragging');
    slider.style.cursor = 'grabbing';
    
    // Disable smooth scrolling during drag for responsive handling
    slider.style.scrollBehavior = 'auto';
    
    // Mark all items as not dragging yet
    document.querySelectorAll('.collection-circle-item').forEach(item => {
      item.setAttribute('data-dragging', 'false');
    });
    
    // Stop any existing animations
    cancelAnimationFrame(rafId);
  }

  function drag(e) {
    if (!isDragging) return;
    
    const isTouch = e.type.includes('touch');
    const pageX = isTouch ? e.touches[0].pageX : e.pageX;
    const deltaX = pageX - startX;
    
    // If moved more than threshold, mark as dragging and prevent click
    if (Math.abs(deltaX) > dragThreshold) {
      hasMoved = true;
      
      // Mark items for dragging to prevent click
      document.querySelectorAll('.collection-circle-item').forEach(item => {
        item.setAttribute('data-dragging', 'true');
      });
      
      // Prevent default to stop page scrolling on touch devices
      if (isTouch && e.cancelable) {
        e.preventDefault();
      }
      
      // Actually scroll the slider with hardware acceleration
      const scrollX = initialScrollLeft - deltaX;
      
      // Use requestAnimationFrame for smoother scrolling
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        slider.scrollLeft = scrollX;
        
        // Store position for momentum calculation
        currentX = pageX;
        positions.push({time: Date.now(), position: pageX});
        if (positions.length > maxPositions) positions.shift();
      });
    }
  }

  function endDrag(e) {
    if (!isDragging) return;
    
    isDragging = false;
    slider.classList.remove('dragging');
    slider.style.cursor = 'grab';
    
    // Re-enable smooth scrolling for momentum effect
    slider.style.scrollBehavior = 'smooth';
    
    if (hasMoved) {
      // Calculate momentum based on recent movements
      if (positions.length >= 2) {
        const lastPosition = positions[positions.length - 1];
        const firstPosition = positions[0];
        const deltaTime = lastPosition.time - firstPosition.time;
        const deltaPosition = lastPosition.position - firstPosition.position;
        
        if (deltaTime > 0) {
          // Calculate velocity and apply continuous momentum animation
          const velocity = deltaPosition / deltaTime;
          applyInstagramStyleMomentum(velocity);
        }
      }
    }
    
    // Reset dragging state
    startX = undefined;
    
    // Resume auto-scroll after a delay if not hovering
    setTimeout(() => {
      if (!slider.matches(':hover')) {
        startAutoScroll();
      }
    }, 2000);
  }

  // Apply Instagram-style continuous momentum scrolling
  function applyInstagramStyleMomentum(velocity) {
    if (Math.abs(velocity) < 0.1) return;
    
    // Calculate final distance based on velocity - more velocity = more distance
    const amplifiedVelocity = velocity * 0.8; // Slightly reduce velocity for more control
    const scrollMultiplier = Math.min(15, Math.max(5, Math.abs(amplifiedVelocity) * 15));
    
    // Create a continuous, physics-based scrolling animation
    const direction = velocity < 0 ? 1 : -1;
    const initialVelocity = Math.abs(amplifiedVelocity) * 100; // Initial velocity in px/sec
    const deceleration = 0.95; // Deceleration factor (0.95 = 5% slowdown per frame)
    
    const initialScrollLeft = slider.scrollLeft;
    let currentVelocity = initialVelocity;
    let totalDistance = 0;
    let lastTimestamp = null;
    
    cancelAnimationFrame(rafId);
    
    // Continuous, frame-by-frame animation that feels like Instagram stories
    function continuousMomentum(timestamp) {
      if (lastTimestamp === null) {
        lastTimestamp = timestamp;
        rafId = requestAnimationFrame(continuousMomentum);
        return;
      }
      
      // Calculate elapsed time since last frame
      const elapsed = timestamp - lastTimestamp;
      lastTimestamp = timestamp;
      
      // Apply deceleration to velocity (feels more natural)
      currentVelocity *= deceleration;
      
      // Calculate how much to move this frame
      const frameDistance = (currentVelocity * elapsed) / 1000;
      totalDistance += frameDistance;
      
      // Apply the scroll
      slider.scrollLeft = initialScrollLeft + (direction * totalDistance);
      
      // Continue animation until velocity becomes very small
      if (currentVelocity > 0.5) {
        rafId = requestAnimationFrame(continuousMomentum);
      } else {
        // Final scroll position reached
        cancelAnimationFrame(rafId);
      }
    }
    
    // Start the continuous animation
    rafId = requestAnimationFrame(continuousMomentum);
  }

  // Easing function for natural movement
  function cubicBezier(p1x, p1y, p2x, p2y, t) {
    const cx = 3 * p1x;
    const bx = 3 * (p2x - p1x) - cx;
    const ax = 1 - cx - bx;
    
    const cy = 3 * p1y;
    const by = 3 * (p2y - p1y) - cy;
    const ay = 1 - cy - by;
    
    function sampleCurveX(t) {
      return ((ax * t + bx) * t + cx) * t;
    }
    
    function sampleCurveY(t) {
      return ((ay * t + by) * t + cy) * t;
    }
    
    function solveCurveX(x, epsilon) {
      let t0 = 0;
      let t1 = 1;
      let t2 = x;
      
      if (x <= 0) return 0;
      if (x >= 1) return 1;
      
      for (let i = 0; i < 8; i++) {
        const x2 = sampleCurveX(t2);
        if (Math.abs(x2 - x) < epsilon) return t2;
        
        const d2 = (3 * ax * t2 + 2 * bx) * t2 + cx;
        if (Math.abs(d2) < 1e-6) break;
        
        t2 = t2 - (x2 - x) / d2;
      }
      
      let t = (t1 + t0) / 2;
      for (let i = 0; i < 8; i++) {
        const x2 = sampleCurveX(t);
        if (Math.abs(x2 - x) < epsilon) return t;
        
        if (x > x2) t0 = t;
        else t1 = t;
        
        t = (t1 + t0) / 2;
      }
      
      return t;
    }
    
    return sampleCurveY(solveCurveX(t, 1 / 1000));
  }

  // Pause auto-scroll
  function pauseAutoScroll() {
    autoScrolling = false;
    cancelAnimationFrame(rafId);
  }

  // Improved auto-scroll functionality with smoother animation
  function startAutoScroll() {
    // Skip auto-scrolling if we have only one item or already scrolling
    if (items.length <= 1 || autoScrolling) return;
    
    autoScrolling = true;
    
    // Use timestamp-based animation with continuous scrolling
    function step(timestamp) {
      if (!autoScrolling) return;
      
      // Calculate time elapsed since last frame
      const elapsed = lastTime ? timestamp - lastTime : 16.7; // ~60fps
      lastTime = timestamp;
      
      // Calculate pixels to move based on time elapsed
      const pixelsToMove = (autoScrollSpeed * elapsed) / 16.7;
      
      // Apply the scroll with a continuous animation
      slider.scrollLeft += pixelsToMove;
      
      // Continue animation loop
      rafId = requestAnimationFrame(step);
    }
    
    // Start animation
    rafId = requestAnimationFrame(step);
  }

  // Touch event handlers with passive option for better performance
  slider.addEventListener('touchstart', startDrag, { passive: true });
  slider.addEventListener('touchmove', drag, { passive: false });
  slider.addEventListener('touchend', endDrag);
  
  // Mouse event handlers
  slider.addEventListener('mousedown', startDrag);
  window.addEventListener('mousemove', drag);
  window.addEventListener('mouseup', endDrag);
  
  // Set initial cursor style
  slider.style.cursor = 'grab';
  
  // Handle hover states for auto-scroll
  slider.addEventListener('mouseenter', pauseAutoScroll);
  
  // Resume auto-scroll on mouse leave
  slider.addEventListener('mouseleave', () => {
    if (startX !== undefined) {
      endDrag();
    }
    startAutoScroll();
  });
  
  // Start auto-scroll after a delay
  setTimeout(startAutoScroll, 1000);
});
